export enum OrderPlatformType {
  WEB = 'web',
  IOS = 'ios',
  ANDROID = 'android',
}
